// import { NumberSymbol } from "@angular/common";

export class GetActiveLockUsersAndLocks {
  populateLockUsers: boolean = true;
  populateLocks: boolean = true;
}
